import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "radio-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.16637 6.16637C9.3882 2.94454 14.6118 2.94454 17.8336 6.16637L17.834 6.16671C21.0554 9.38857 21.0553 14.6119 17.8336 17.8336C14.6118 21.0554 9.38818 21.0554 6.16637 17.8336C2.94454 14.6118 2.94454 9.38818 6.16637 6.16637L6.16637 6.16637ZM18.8943 18.8943C22.7019 15.0867 22.7019 8.91332 18.8943 5.10571C15.0867 1.2981 8.91332 1.2981 5.10571 5.10571C1.2981 8.9133 1.2981 15.0867 5.10571 18.8943C8.9133 22.7019 15.0867 22.7019 18.8943 18.8943ZM9.7019 9.70191C10.9711 8.4327 13.0289 8.4327 14.2981 9.7019C15.5673 10.9711 15.5673 13.0289 14.2981 14.2981C13.0289 15.5673 10.9711 15.5673 9.70191 14.2981L9.17596 14.824L9.70191 14.2981C8.4327 13.0289 8.4327 10.9711 9.7019 9.70191ZM8.64125 8.64124C10.4961 6.78638 13.5033 6.78625 15.3584 8.64086L15.3588 8.64125C17.2137 10.4962 17.2137 13.5038 15.3588 15.3588C13.5038 17.2137 10.4962 17.2137 8.64125 15.3588C6.78625 13.5038 6.78625 10.4962 8.64125 8.64124Z"
    }, null, -1)
  ])))
}
export default { render: render }